import { render, staticRenderFns } from "./BusinessNameAttachmentsEscalated.vue?vue&type=template&id=66559638&scoped=true&"
import script from "./BusinessNameAttachmentsEscalated.vue?vue&type=script&lang=js&"
export * from "./BusinessNameAttachmentsEscalated.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameAttachmentsEscalated.vue?vue&type=style&index=0&id=66559638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66559638",
  null
  
)

export default component.exports